import _ from 'lodash';
import { Component, DestroyRef, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { CookieService } from 'ngx-cookie-service';
import { filter } from 'rxjs/operators';
import { LoadUser } from '../../features/data/data.actions';
import { selectUser } from '../../features/data/data.selectors';
import * as DialogActions from '../../../dialog/features/dialog.actions';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  public steps = [
    {id: 1, name: 'Create Account'},
    {id: 2, name: 'Organization Info'},
    {id: 3, name: 'Bank Information'},
    {id: 4, name: 'Verify Organization'},
    {id: 5, name: 'Choose Membership'},
    {id: 6, name: 'Done!'},
  ];
  public currentStep = 1;
  public showLogoutLink = false;

  @ViewChild('scrollMenu') scrollMenu: ElementRef;

  public user$ = this.store.pipe(
    select(selectUser)
  );

  constructor(
    private store: Store,
    private cookieService: CookieService
  ) { }

  ngOnInit(): void {
    const access_token = this.cookieService.get('accessToken');

    if (access_token) {
      this.store.dispatch({
        type: LoadUser.type
      });
    }

    this.user$.pipe(
      filter(user => !_.isNull(user)),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(user => {
      this.showLogoutLink = true;

      switch (user.status) {
        case 5:
          this.currentStep = user.emailVerified ? 2 : 1;
          break;
        case 6:
          this.currentStep = 3;
          break;
        case 7:
          this.currentStep = 4;
          break;
        case 8:
          this.currentStep = 5;
          break;
        case 0:
          this.currentStep = 6;
          break;
      }
    });
  }

  onChangeStep(value: number = 1): void {
    this.currentStep = value;
  }

  onLogout(): void {
    window['orgSignUp'].doLogout();
  }

  onSupport(): void {
    const action = DialogActions.openDialog({
      payload: {
        name: "ContactUs",
        options: {
          size: 'default',
          modalClass:'modal--paybee',
          containerClass:'mdb-modal-backdrop-paybee'
        },
      }
    });
    this.store.dispatch(action);
  }
}
